export default __webpack_public_path__ + "static/media/orders.ee1d36dc.png";